import syncValidator from '../../ProductListingBaseForm/syncValidator'
import { formDecorator } from '../../../Common/forms'
import { PROPOSAL_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'
import _ from 'lodash'
import { change } from 'redux-form'
import { PRODUCT_SHIP_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { getCvsQtyLimitMaxByPrice } from '../ProposalForm/Shared/util'
import { isNotPhaseOverview } from '../../../../../lib/proposalHelper'

/**
 * 安全庫存量在 newProduct 且快速到貨的狀況下，必須為 1
 */
const syncSafeStockQtyByShipType = (values, previousValues, dispatch) => {
  const shipTypeIdFieldKey = 'product.shipType.id'
  const shipTypeId = +_.get(values, shipTypeIdFieldKey, '')
  const isExpress24HR = shipTypeId === PRODUCT_SHIP_TYPE.EXPRESS_24HR
  if (isExpress24HR) {
    const actionForChangeSafeStockQty = change(PROPOSAL_LISTING_FORM_KEY, 'product.safeStockQty', 1)
    dispatch(actionForChangeSafeStockQty)
  }
}

/**
 * price 改變，連動 單次限購數量(超取) 上限
 */
const syncCvsPurchaseQtyLimitMaxByPrice = (values, previousValues, dispatch) => {
  const priceFieldKey = 'listing.price'
  const price = _.get(values, priceFieldKey, '')
  const prevPrice = _.get(previousValues, priceFieldKey, '')
  if (price !== prevPrice) {
    const cvsQtyLimitMax = getCvsQtyLimitMaxByPrice(price)
    const actionForChangeCvsPurchaseQtyLimitMax = change(
      PROPOSAL_LISTING_FORM_KEY,
      'setting.cvsQtyLimitMax',
      cvsQtyLimitMax
    )
    dispatch(actionForChangeCvsPurchaseQtyLimitMax)
  }
}

/**
 * A callback function that will be called with all the form values any time any of the form values change.
 *
 * @see [Redux Form - `reduxForm()`](https://redux-form.com/8.1.0/docs/api/reduxform.md/)
 */
const onProposalListingFormChange = (values, dispatch, props, previousValues) => {
  const phase = _.get(values, 'setting.phase')
  if (isNotPhaseOverview(phase)) {
    const proposalType = _.get(values, 'setting.proposalType', PROPOSAL_TYPE.NEW_LISTING)
    switch (proposalType) {
      case PROPOSAL_TYPE.NEW_LISTING: {
        syncCvsPurchaseQtyLimitMaxByPrice(values, previousValues, dispatch)
        break
      }
      case PROPOSAL_TYPE.NEW_PRODUCT: {
        syncSafeStockQtyByShipType(values, previousValues, dispatch)
        break
      }

      default:
        break
    }
  }
}

export const PROPOSAL_LISTING_FORM_CONFIG = {
  form: PROPOSAL_LISTING_FORM_KEY,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // unregister fields on unmount
  validate: syncValidator,
  asyncBlurFields: [],
  onChange: onProposalListingFormChange
}

function withProposalListingForm (MainComponent) {
  return formDecorator(PROPOSAL_LISTING_FORM_CONFIG)(MainComponent)
}

export default withProposalListingForm
